import React from 'react'
import TableCellDesktop from './TableCellDesktop'

const TableCellSemaine = ({ item }) => {
  return (
    <TableCellDesktop
      max={150}
      value={item.nom}
    />
  )
}

export default TableCellSemaine
